PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
PREFIX ccf: <http://purl.org/ccf/>
PREFIX DSGraphs: <https://purl.humanatlas.io/collection/ds-graphs>
PREFIX DSGraphsExtra: <https://purl.humanatlas.io/graph/ds-graphs-enrichments>
PREFIX HRA: <https://purl.humanatlas.io/collection/hra-api>

CONSTRUCT {
  [] a ccf:AggregateResult ;
     rdfs:label "Consortia" ;
     ccf:count ?consortium_count .
  [] a ccf:AggregateResult ;
     rdfs:label "Tissue Data Providers" ;
     ccf:count ?provider_count .
  [] a ccf:AggregateResult ;
     rdfs:label "Donors" ;
     ccf:count ?donor_count .
  [] a ccf:AggregateResult ;
     rdfs:label "Organs" ;
     ccf:count ?organ_count .
  [] a ccf:AggregateResult ;
     rdfs:label "Extraction Sites" ;
     ccf:count ?rui_location_count .
  [] a ccf:AggregateResult ;
     rdfs:label "Tissue Blocks" ;
     ccf:count ?block_count .
  [] a ccf:AggregateResult ;
     rdfs:label "Tissue Sections" ;
     ccf:count ?section_count .
  [] a ccf:AggregateResult ;
     rdfs:label "Tissue Datasets" ;
     ccf:count ?dataset_count .
}
FROM DSGraphs:
FROM NAMED DSGraphsExtra:
WHERE {
  {
    SELECT 
      (COUNT(DISTINCT ?donor) AS ?donor_count)
      (COUNT(DISTINCT ?organ) AS ?organ_count)
      (COUNT(DISTINCT ?consortium) AS ?consortium_count)
      (COUNT(DISTINCT ?provider) AS ?provider_count)
      (COUNT(DISTINCT ?block) AS ?block_count)
      (COUNT(DISTINCT ?rui_location) AS ?rui_location_count)
      (COUNT(DISTINCT ?section) AS ?section_count)
      (COUNT(DISTINCT ?dataset) AS ?dataset_count)
    WHERE {
      ?block ccf:comes_from ?donor ;
        ccf:has_registration_location ?rui_location .
      OPTIONAL {
        ?block ccf:subdivided_into_sections ?section .
      }
      OPTIONAL {
        {
          ?block ccf:subdivided_into_sections ?section .
          ?section ccf:generates_dataset ?dataset .
        }
        UNION {
          ?block ccf:generates_dataset ?dataset .
        }
      }
      OPTIONAL {
        GRAPH DSGraphsExtra: {
          ?rui_location ccf:collides_with ?organ .
        }
        GRAPH HRA: {
          ?refOrgan ccf:has_reference_organ ?refOrgan ;
            ccf:representation_of ?organ .
        }
      }
      OPTIONAL {
        ?donor ccf:consortium_name ?consortium .
      }
      OPTIONAL {
        ?donor ccf:tissue_provider_name ?provider .
      }
      #{{FILTER}}
    }
  }
}
